export const HOVER = 'hover';
export const FOCUS = 'focus';
export const SELECT = 'select';
